import React from 'react'

import styled from 'theme/styled-components'

import Keyboard from 'react-simple-keyboard'

import 'react-simple-keyboard/build/css/index.css'

import { defaultLayout, shiftLayout, display } from './KeyboardUtils'

interface Props {
  onRef: (r: any) => void
  showKeyboard: boolean
  setShowKeyboard: (showKeyboard: boolean) => void
  text: string
  setText: (text: string) => void
  textInputRef?: React.RefObject<HTMLInputElement>
}

const TotemKeyboard = ({ onRef, showKeyboard, setShowKeyboard, text, setText, textInputRef }: Props) => {
  const [layout, setLayout] = React.useState('shift')

  const onKeyPress = (button: string) => {
    switch (button) {
      case '{shift}':
        setLayout((prevLayout) => (prevLayout === 'default' ? 'shift' : 'default'))
        break
      case '{enter}':
        setShowKeyboard(false)
        textInputRef && textInputRef.current?.blur()
      default:
        setLayout('default')
    }
  }

  return (
    <KeyboardContainer hidden={!showKeyboard}>
      <Keyboard
        layout={{
          default: defaultLayout,
          shift: shiftLayout,
        }}
        display={display}
        keyboardRef={onRef}
        layoutName={!text.length ? 'shift' : layout}
        onChange={setText}
        onKeyPress={onKeyPress}
        onKeyReleased={() => textInputRef && textInputRef.current?.focus}
        useTouchEvents
      />
    </KeyboardContainer>
  )
}

export default TotemKeyboard

const KeyboardContainer = styled('div')<{ hidden: boolean }>`
  position: relative;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scale(3);
  display: grid;
  grid-template-rows: ${(props) => (props.hidden ? '0fr' : '1fr')};
  overflow: hidden;
  opacity: ${(props) => (props.hidden ? 0 : 1)};
  transition: grid-template-rows 0.2s ease-in-out, margin 0.4s ease-in-out, opacity 0.2s ease-in-out 0.1s;
  width: 33%;
  margin: ${(props) => (props.hidden ? '0 0 -30px 0' : '2% 0 25% 0')};
  transform-origin: top center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 0.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`
